import type { AddFileErrorKey } from '@/company-portal/add-file/add-file-form-errors.types';
import { useAddFileStore } from '@/company-portal/add-file/add-file.store';
import { clearServerValidationError, fileSubmissionErrors } from '@/company-portal/add-file/submission-error';
import { computed, watch } from 'vue';

/**
 * Single validation-error source for the Add File sections shared by the old and new experiences.
 * The legacy (jQuery) submit writes errors to the submission-error reactive; this watcher mirrors them
 * into the store so the sections — which read only the store — display them (inert in the new experience,
 * where nothing writes that reactive). Clearing removes the key from both so neither keeps a stale error.
 * Retiring the legacy experience later is a change confined to this file + its provider in AddFileForm.
 */
export const useAddFileError = () => {
    const addFileStore = useAddFileStore();

    watch(
        () => fileSubmissionErrors.validationErrors,
        errors => {
            addFileStore.submissionErrors = errors;
        },
    );

    const clearError = (key: AddFileErrorKey) => {
        clearServerValidationError(key);
        addFileStore.clearServerValidationError(key);
    };

    return {
        serverValidationErrors: computed(() => addFileStore.serverValidationErrors),
        clearServerValidationError: clearError,
    };
};
